// Change this
const module = 'fields'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/fields/Index'
import Create from '@/views/fields/Create'
import Edit from '@/views/fields/Edit'
import Settings from '@/views/fields/Settings'
import MasterCalendar from '@/views/fields/MasterCalendar'
import Calendar from '@/views/fields/Calendar'
import LiveCalendar from '@/views/fields/LiveCalendar'

var prefix = '/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/settings/:id`,
        name: `${module}Settings`,
        component: Settings,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/master-calendar/:id`,
        name: `${module}MasterCalendar`,
        component: MasterCalendar,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/calendar/:id`,
        name: `${module}Calendar`,
        redirect: to => {
            return { path: prefix+`${module}/live-calendar/:id` }
        },
    },
    {
        path: prefix+`${module}/live-calendar/:id`,
        name: `${module}LiveCalendar`,
        component: LiveCalendar,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
